import spec from "./readme.md";

export const docs = {
  swagger: "2.0",
  info: {
    description: spec,
    version: "1.0.0",
    title: "Path to Agility Navigator API",
  },
  host: "https://api.p2anav.com",
  basePath: "/v1",
  tags: [
    {
      name: "apiKey",
      description:
        "Use the apiKey to get auth token which is needed for all other calls",
    },
    {
      name: "api",
      description:
        "External endpoints for consuming various kinds of P2ANav data",
    },
  ],
  paths: {
    "/apiKey/token": {
      post: {
        tags: ["apiKey"],
        summary: "",
        description: "",

        consumes: ["application/json"],
        produces: ["application/json"],
        parameters: [
          {
            in: "body",
            name: "apiKey",
            description:
              "The apiKey is obtained in the P2ANav app and allows you to obtain a token",
            required: true,
          },
        ],
        responses: {
          200: {
            description: "successful operation",
            schema: { $ref: "#/definitions/TokenResponse" },
          },
        },
      },
    },
    "/api/assessment": {
      get: {
        tags: ["api"],
        summary:
          "Read-only access to the Assessment Answers which are scores for Agile Capabilities organized by the company hierarchy",
        description: "",

        consumes: ["application/json"],
        produces: ["application/json"],
        parameters: [
          {
            in: "headers",
            name: "authorization",
            description: "Company API Token, set as `Bearer {token}`",
            required: true,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "page",
            description: "Page you want to get (starting from 1)",
            required: false,
          },
          {
            in: "query",
            name: "size",
            description: "How many items do you want to get per page",
            required: false,
          },
          {
            in: "query",
            name: "organizationId",
            description: "Id of the organization you want to get info",
            required: false,
          },
          {
            in: "query",
            name: "startDate",
            description:
              "if present all items returned are for assessments dated after or on this date (format: mm/dd/yyyy).",
            required: false,
          },
          {
            in: "query",
            name: "endDate",
            description:
              "if present all items returned are for assessments dated before or on this date (format: mm/dd/yyyy).",
            required: false,
          }
        ],
        responses: {
          200: {
            description: "successful operation",
            schema: { $ref: "#/definitions/AssessmentResponse" },
          },
        },
      },
    },
    "/api/workItems": {
      get: {
        tags: ["api"],
        summary:
          "Read-only access to the Action Items which are used to manage tasks",
        description: "",

        consumes: ["application/json"],
        produces: ["application/json"],
        parameters: [
          {
            in: "headers",
            name: "authorization",
            description: "Company API Token, set as `Bearer {token}`",
            required: true,
            schema: {
              type: "string",
            },
          },
          {
            in: "query",
            name: "page",
            description: "Page you want to get (starting from 1)",
            required: false,
          },
          {
            in: "query",
            name: "size",
            description: "How many items do you want to get per page",
            required: false,
          },
          {
            in: "query",
            name: "organizationId",
            description: "Id of the organization you want to get info",
            required: false,
          },
          {
            in: "query",
            name: "startDate",
            description:
              "if present all action items returned will be created on or after this date (format: mm/dd/yyyy)",
            required: false,
          },
          {
            in: "query",
            name: "endDate",
            description:
              "if present all action items will be created before or on this date (format: mm/dd/yyyy)",
            required: false,
          },
        ],
        responses: {
          200: {
            description: "successful operation",
            schema: { $ref: "#/definitions/WorkItemsResponse" },
          },
        },
      },
    },
    "/api/teamHierarchy": {
      get: {
        tags: ["api"],
        summary:
          "Read-only access to the metadata for each team in the company",
          description: "Returns a list of all teams in the company, including the system and organization the team is a member of.",

        consumes: ["application/json"],
        produces: ["application/json"],
        parameters: [
          {
            in: "headers",
            name: "authorization",
            description: "Company API Token, set as `Bearer {token}`",
            required: true,
            schema: {
              type: "string",
            },
          },
        ],
        responses: {
          200: {
            description: "successful operation",
            schema: { $ref: "#/definitions/TeamHierarchyResponse" },
          },
        },
      },
    },
  },
  definitions: {
    TokenResponse: {
      type: "object",
      properties: {
        token: { type: "string" },
      },
    },
    WorkItemsResponse: {
      type: "object",
      properties: {
        totalItems: {
          type: "integer",
          example: 1,
          description: "total items",
        },
        totalPages: {
          type: "integer",
          example: 1,
          description: "total pages",
        },
        currentPage: {
          type: "integer",
          example: 1,
          description: "currentPage",
        },
        items: {
          type: "array",
          example: [
            {
              id: "a2c67063-6e54-48f6-85fc-1a6788dfbf2c",
              name: "test",
              description: "",
              estimate: null,
              agileCapabilityId: 140,
              blocked: false,
              workItemStateId: "a42d1358-8c91-4c80-9ec6-234181b2db58",
              createdAt: "2023-02-09T18:17:33.472Z",
              updatedAt: "2023-02-09T18:17:33.472Z",
              deletedAt: null,
              assignees: ["luis"],
              status: "backlog",
              agileCapabilityName: "Portfolio Sequencing",
            },
            {
              id: "49c33fe5-939f-4503-bf8e-044cc739b506",
              name: "test",
              description: "",
              estimate: null,
              agileCapabilityId: null,
              blocked: false,
              workItemStateId: "a42d1358-8c91-4c80-9ec6-234181b2db58",
              createdAt: "2023-02-09T18:10:53.823Z",
              updatedAt: "2023-02-09T18:10:53.823Z",
              deletedAt: null,
              assignees: [],
              status: "backlog",
              agileCapabilityName: "",
            },
          ],
          items: {
            type: "object",
            properties: {
              id: {
                type: "string",
                example: "49c33fe5-939f-4503-bf8e-044cc739b506",
              },
              name: { type: "string" },
              description: { type: "string" },
              agileCapabilityId: { type: "number" },
              blocked: { type: "boolean" },
              workItemStateId: { type: "string" },
              createdAt: { type: "string" },
              updatedAt: { type: "string" },
              deletedAt: { type: "string" },
              assignees: { type: "array" },
              status: { type: "string" },
              agileCapabilityName: { type: "string" },
            },
          },
        },
      },
    },
    AssessmentResponse: {
      type: "object",
      properties: {
        page: {
          type: "integer",
          example: 1,
          description: "Current Page",
        },
        size: {
          type: "integer",
          example: 1,
          description: "How many items are in this page",
        },
        total: {
          type: "integer",
          example: 1,
          description: "Total amount of items matching filters",
        },
        company: {
          type: "object",
          description: "Company information",
          properties: {
            id: { type: "integer", example: 1 },
            name: { type: "string" },
          },
        },
        data: {
          type: "array",
          items: {
            type: "object",
            properties: {
              exportDate: {
                type: "string",
                example: "2023-02-07T14:53:52.337Z",
              },
              notes: { type: "string" },
              rating: { type: "string", example: "25%" },
              assessment: {
                type: "object",
                properties: {
                  id: { type: "integer" },
                  name: { type: "string", example: "First Quarter" },
                  date: { type: "string", example: "02/02/2023" },
                  status: { type: "string" },
                },
              },
              level: {
                type: "object",
                properties: {
                  name: { type: "string", example: "Team" },
                },
              },
              agileCapability: {
                type: "object",
                properties: {
                  id: { type: "integer", example: 111 },
                  name: { type: "string", example: "Clear Team Purpose" },
                },
              },
              agileOutcome: {
                type: "object",
                properties: {
                  id: { type: "integer", example: 31 },
                  name: { type: "string", example: "Team Formed" },
                },
              },
              stage: {
                type: "object",
                properties: {
                  id: { type: "integer", example: 6 },
                  name: { type: "string", example: "Align" },
                },
              },
              organization: {
                type: "object",
                properties: {
                  id: { type: "integer", example: 2 },
                  name: { type: "string", example: "Organization 1" },
                  system: {
                    type: "object",
                    properties: {
                      id: { type: "integer", example: 1 },
                      name: { type: "string", example: "System 1" },
                      team: {
                        type: "object",
                        properties: {
                          id: { type: "integer", example: 1 },
                          name: { type: "string", example: "Team 1" },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    TeamHierarchyResponse: {
      type: "object",
      properties: {
        data: {
          type: "array",
          items: {
            type: "object",
            example: [{
              organizationName: 'organization 1',
              organizationId: 1,
              systemName: 'system 1',
              systemId: 1,
              teamName: 'team 1',
              teamId: 1,
              teamStatus: 'DELETED',
            },
            {
              organizationName: 'organization 1',
              organizationId: 1,
              systemName: 'system 2',
              systemId: 2,
              teamName: 'team 2',
              teamId: 2,
              teamStatus: 'ACTIVE',
            }],
            properties: {
              organizationName: { type: "string", example: "Organization 1"  },
              organizationId: { type: "integer", example: 1  },
              systemName: { type: "string", example: "System 1" },
              systemId: { type: "integer", example: 1  },
              teamName: { type: "string", example: "Team 1" },
              teamId: { type: "integer", example: 1  },
              teamStatus: { type: "string", example: 'DELETED'  }
            }
          }
        }
      }
    }
  },
};
